import { DELETE_CONFIRMATION_MODAL_TEXT } from './text';

export const getDeleteConfirmationText = ({
	itemLabel = DELETE_CONFIRMATION_MODAL_TEXT.defaultItemLabel,
	extraLabel = '',
}) => {
	const extraSentence = extraLabel ? ` ${extraLabel}` : '';

	return `${DELETE_CONFIRMATION_MODAL_TEXT.deletePrefix} ${itemLabel} ${DELETE_CONFIRMATION_MODAL_TEXT.deleteEffect}${extraSentence} ${DELETE_CONFIRMATION_MODAL_TEXT.proceedWithCaution}`;
};
